import { createSelector } from 'reselect';

import { selectSelectedCartItems } from './selectSelectedCartItems';

export const selectSelectedTotalPrice = createSelector(
    [selectSelectedCartItems],
    (items) => items.reduce((acc, item) => acc + item.price * item.quantity, 0),
);
